<template>
  <main>
    <div>
      <form
        autocomplete="off"
        @submit.prevent="handleFormSubmit"
        class="flex-row"
      >
        <div>
          <input
            required
            minlength="3"
            name="memo"
            class="form-input"
            type="text"
            placeholder="New memo..."
            v-model="memo"
            maxlength="200"
          />
        </div>
        <button :class="loading && 'loading'">
          <svg
            width="36"
            height="36"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="#707594" d="M0 0l20 10L0 20V0zm0 8v4l10-2L0 8z" />
          </svg>
        </button>
      </form>
      <small class="memo-input-count">{{ memo.length }}/200</small>
    </div>

    <div class="tab-wrapper">
      <button
        @click="toggleTab('active')"
        :class="tab === 'active' ? 'is-active' : ''"
      >
        Active
      </button>
      <button
        @click="toggleTab('done')"
        :class="tab === 'done' ? 'is-active' : ''"
      >
        Done
      </button>
    </div>
    <div v-if="getLoading" class="loader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="
          margin: auto;
          background: none;
          display: block;
          shape-rendering: auto;
        "
        width="224px"
        height="224px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle cx="50" cy="16" r="6" fill="#707594">
          <animate
            attributeName="cy"
            dur="0.8s"
            repeatCount="indefinite"
            calcMode="spline"
            keySplines="0.45 0 0.9 0.55;0 0.45 0.55 0.9"
            keyTimes="0;0.5;1"
            values="16;84;16"
          ></animate>
        </circle>
        <!-- [ldio] generated by https://loading.io/ -->
      </svg>
    </div>
    <div v-else class="memo-items">
      <div v-if="tab === 'active'">
        <MemoItem
          v-for="memo in getActiveMemo"
          :key="memo.id"
          :id="memo.id"
          :time="memo.time"
          :done="memo.done"
          :memo="memo.memo"
        />
      </div>
      <div v-if="tab === 'done'">
        <MemoItem
          v-for="memo in getDoneMemo"
          :key="memo.id"
          :id="memo.id"
          :done="memo.done"
          :time="memo.time"
          :memo="memo.memo"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MemoItem from "./MemoItem.vue";

export default {
  name: "PageBody",
  components: {
    MemoItem,
  },
  data() {
    return {
      memo: "",
      tab: "active",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getActiveMemo", "getDoneMemo", "getLoading"]),
  },
  methods: {
    ...mapActions(["addMemo", "toggleMemo"]),
    async handleFormSubmit() {
      this.loading = true;
      const payload = this.memo;
      this.memo = "";
      await this.addMemo(payload);
      this.loading = false;
    },

    toggleTab(tab) {
      this.tab = tab;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
main {
  max-width: 720px;
  margin: auto;
  padding: 60px 15px;

  form.flex-row {
    display: flex;
    align-items: center;
    div:first-child {
      flex: 1;
    }

    button {
      margin-left: 10px;
      height: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #707594;
      background: transparent;
      border: none;
      cursor: pointer;
      &.loading {
        &::before {
          background: transparent;
        }
      }
    }
  }

  .tab-wrapper {
    display: flex;
    align-items: center;
    width: max-content;
    margin: 40px auto;
    border-radius: 4px;
    padding: 0;

    button {
      padding: 10px 20px;
      height: 50px;
      border-radius: 4px 0 0 4px;
      margin: 0;
      background: #11152b;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      border: none;
      border: 1.5px solid #707594a3;
      opacity: 0.5;
      &:last-child {
        border-radius: 0 4px 4px 0;
      }

      &.is-active {
        background: #707594;
        color: #fff;
        opacity: 1;
      }
    }
  }

  .memo-items {
    max-height: 400px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .loader {
    display: flex;
    justify-content: center;
  }
}
</style>
